import { fieldIsInvalid, fieldIsRequired, getValidationResult } from 'shared/utils/tools'
import uuid from 'uuid/v4'
import * as yup from 'yup'

export const confirmationSchema = yup.object().shape({
  id: yup.string().notRequired(),
  message: yup.string().notRequired(),
  type: yup.string().notRequired(),
  categories: yup
    .array()
    .of(yup.string())
    .notRequired(),
})

export type ConfirmationType = yup.InferType<typeof confirmationSchema>

export function getEmptyConfirmation(): ConfirmationType {
  return {
    id: uuid(),
    message: '',
    type: '',
    categories: [],
  }
}

export default function validator(data: ConfirmationType) {
  return getValidationResult(data, confirmationSchema)
}
